import React, { useEffect, useState } from "react";
import Arrow from "../../../assets/Blue-arrow-right.svg";
import Calender from "../../../assets/Calender.svg";
import DatePicker from "react-datepicker";
import dateFormat from "dateformat";
import "react-datepicker/dist/react-datepicker.css";
import "./FilterFlights.css";
import { ActivityPopup } from "../../../ReusableComponents/ActivityPopup";
import { useSelector } from "react-redux";

const DatePickerDateOnly = ({
  setOpenDatepicker,
  fromDateTime,
  toDateTime,
  fromdatePicker,
  todatePicker,
  handleFilterChange,
  isDisabled,
}) => {

  const user = useSelector((state) => state.profile?.user)

  const [dateError, setError] = useState({
    error: false,
    message: "",
  });

  const isSameDate = (date1, date2) => {
    return (
      new Date(date1)?.getDate() === new Date(date2)?.getDate() &&
      new Date(date1)?.getMonth() === new Date(date2)?.getMonth() &&
      new Date(date1)?.getFullYear() === new Date(date2)?.getFullYear()
    );
  };

  const handleFromDate = (fromDate) => {
    // Strip time from date
    fromDate = new Date(fromDate.setHours(0, 0, 0, 0));

    if (isSameDate(fromDate, toDateTime)) {
      if (new Date(fromDate).getTime() > new Date(toDateTime).getTime()) {
        setError({
          error: true,
          message: "From date cannot be greater than To Date!",
        });
        return;
      }
    }
    if (new Date(fromDate) > new Date()) {
      setError({
        error: true,
        message: "From date cannot be greater than today date!",
      });
      return;
    }
    if (toDateTime && new Date(fromDate) >= new Date(toDateTime)) {
      setError({
        error: true,
        message: "From date cannot be greater than To Date!",
      });
      return;
    }
    handleFilterChange("fromDateTime", fromDate);
  };

  const handleToDate = (toDate) => {
        if (isSameDate(new Date(), new Date(toDate))) {
            if (new Date(toDate).getTime() < new Date(fromDateTime).getTime()) {
                setError((prev) => ({
                    ...prev,
                    error: true,
                    message: "to date time can not be less than from date time"
                }))
                return;
            }
            handleFilterChange("toDateTime", toDate);

        }
        if (new Date(toDate).setHours(0, 0, 0, 1) > new Date().setHours(0, 0, 0, 1)) {
            setError((prev) => ({
                ...prev,
                error: true,
                message: "You cannot select the date beyond today's date"
            }))
            return;
        }
        if (new Date(toDate) < new Date(fromDateTime)) {
            setError((prev) => ({
                ...prev,
                error: true,
                message: "To date can not be less than from Date !"
            }))
            return;
        }


        if (toDateTime === undefined) {
            if (!new Date(toDate).getHours()) {
                toDate = new Date(toDate).setHours(23, 59, 59, 999);
                handleFilterChange("toDateTime", new Date(toDate));

            }
            else {
                const selectedTime = new Date(toDate);
                handleFilterChange("toDateTime", new Date(selectedTime));
            }
        }
        handleFilterChange("toDateTime", new Date(toDate));
    }

  return (
    <div
      className="dates__wrapper"
      style={
        isDisabled
          ? { cursor: "not-allowed", opacity: "0.5" }
          : { cursor: "auto", opacity: "1" }
      }
    >
      <ActivityPopup
        open={dateError.error}
        msg={dateError.message}
        close={() =>
          setError({
            error: false,
            message: "",
          })
        }
      />
      <div
        style={
          isDisabled
            ? { cursor: "not-allowed", opacity: "0.5" }
            : { cursor: "auto", opacity: "1" }
        }
        className="single__date"
        onClick={() => {
          if (!isDisabled) {
            setOpenDatepicker((prev) => ({ ...prev, fromdatePicker: true }));
          }
        }}
      >
        <div>
          <img src={Calender} alt="calendar" />
        </div>
        {fromDateTime !== undefined && fromDateTime !== null ? (
          <div className="date_time_wrapper">
            <span>{dateFormat(fromDateTime, "dd/mm/yyyy")}</span>
          </div>
        ) : (
          <div className="undefined_date_wrapper">
            <span className="undefined_date">--/--/----</span>
          </div>
        )}
      </div>
      <div
        className="arrow__icon"
        style={
          isDisabled
            ? { cursor: "not-allowed", opacity: "0.5" }
            : { cursor: "auto", opacity: "1" }
        }
      >
        <img src={Arrow} alt="arrow" />
      </div>
      <div
        style={
          isDisabled
            ? { cursor: "not-allowed", opacity: "0.5" }
            : { cursor: "auto", opacity: "1" }
        }
        className="single__date"
        onClick={() => {
          if (!isDisabled) {
            setOpenDatepicker((prev) => ({ ...prev, todatePicker: true }));
          }
        }}
      >
        <div>
          <img src={Calender} alt="calendar" />
        </div>
        {toDateTime !== undefined && toDateTime !== null ? (
          <div className="date_time_wrapper">
            <span>{dateFormat(toDateTime, "dd/mm/yyyy")}</span>
          </div>
        ) : (
          <div className="undefined_date_wrapper">
            <span className="undefined_date">--/--/----</span>
          </div>
        )}
      </div>
      <div className="react-datepicker-wrapper-custom-1 ">
        <DatePicker
          open={fromdatePicker && !isDisabled}
          className="hidden"
          selected={fromDateTime}
          value={fromDateTime}
          maxDate={new Date()}
          minDate={user.created_on ? new Date(user.created_on) : null}
          onChange={(date) => handleFromDate(date)}
          popperPlacement="bottom"
          tetherConstraints={[]}
          popperModifiers={[
            {
              name: "flip",
              options: {
                fallbackPlacements: ["bottom"],
                allowedAutoPlacements: ["bottom"],
              },
            },
          ]}
          onClickOutside={() =>
            setOpenDatepicker((prev) => ({
              ...prev,
              fromdatePicker: false,
              todatePicker: false,
            }))
          }
          placeholderText="From Date"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          dateFormat="dd/MM/yyyy"
          disabled={isDisabled}
        />
      </div>
      <div className="react-datepicker-wrapper-custom-2">
        <DatePicker
          open={todatePicker && !isDisabled}
          className="hidden"
          selected={toDateTime}
          maxDate={new Date()}
          minDate={user.created_on ? new Date(user.created_on) : null}
          value={toDateTime}
          onChange={(date) => handleToDate(date)}
          popperPlacement="bottom"
          tetherConstraints={[]}
          popperModifiers={[
            {
              name: "flip",
              options: {
                fallbackPlacements: ["bottom"],
                allowedAutoPlacements: ["bottom"],
              },
            },
          ]}
          onClickOutside={() =>
            setOpenDatepicker((prev) => ({
              ...prev,
              fromdatePicker: false,
              todatePicker: false,
            }))
          }
          placeholderText="To Date"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          dateFormat="dd/MM/yyyy"
          disabled={isDisabled}
        />
      </div>
    </div>
  );
};

export default DatePickerDateOnly;